import { useState, useEffect } from "react";
import { messaging } from "../lib/firebase";
import { getToken } from "firebase/messaging";
import Swal from "sweetalert2";

const publicVapidKey =
  "BNlUqSk4HSiv20Lfiod23kj06-VjI9J_bxp21VNOqKmJphjiA1WUOU2vZujTotgjnuqDaaTRkmWfqzsdDLB2qp8";

const EnableNotificationsButton = ({ emailAddress, role }) => {
  const [loading, setLoading] = useState(false);
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const savedToken = user?.Token;
    setShowButton(!savedToken);
  }, []);

  const requestPermission = async () => {
    if (loading) return;

    setLoading(true);

    try {
      const authToken = localStorage.getItem("authToken");

      const permission = await Notification.requestPermission();

      if (permission !== "granted") {
        await Swal.fire({
          title: "Error!",
          text: "Notification permission denied!",
          icon: "error",
        });

        setLoading(false);
        return;
      }

      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );

      await navigator.serviceWorker.ready;

      const token = await getToken(messaging, {
        vapidKey: publicVapidKey,
        serviceWorkerRegistration: registration,
      });

      const savedToken = localStorage.getItem("fcm_token");

      if (savedToken === token) {
        await Swal.fire(
          "Info",
          "Notifications already enabled on this device",
          "info"
        );

        setShowButton(false);
        setLoading(false);
        return;
      }

      await fetch(
        "https://api.kunalsdrumclass.com/api/SaveToken",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            emailAddress,
            role,
            token,
          }),
        }
      );

      const storedUser = JSON.parse(localStorage.getItem("authUser"));
      const updatedUser = {
        ...storedUser,
        Token: token,
      };
      localStorage.setItem("authUser", JSON.stringify(updatedUser));

      await Swal.fire(
        "Success!",
        "Notifications enabled successfully!",
        "success"
      );

      setShowButton(false);

    } catch (err) {
      console.error("Notification error:", err);

      await Swal.fire({
        title: "Success!",
        text: "Notifications permission granted, click again to enable notifications.",
        icon: "success",
      });

    } finally {
      setLoading(false);
    }
  };

  if (!showButton) return null;

  return (
    <button
      className="btn btn-primary dropdown-toggle waves-effect waves-light"
      onClick={requestPermission}
      disabled={loading}
    >
      {loading ? "Enabling..." : "Enable Notifications"}
    </button>
  );
};

export default EnableNotificationsButton;
